import { combineReducers } from "redux";
import filterMenu from "./contract.dashboard.reducer";


export const dashboardContract = combineReducers({
  filterMenu,
});


